import Vue from 'vue'
import App from './App.vue'
//import './registerServiceWorker'
//import router from './router'
//import store from './store'
import components from './components';
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'

Vue.config.productionTip = false

new Vue({
  //router,
  //store,
  components,
  render: h => h(App)
}).$mount('#app')
